import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../environment';

@Injectable()
export class ApimInterceptor implements HttpInterceptor {
  private env = inject(environment);

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    const subscriptionKey = this.env.apimSubscriptionKey;

    if (subscriptionKey && request.url.startsWith(this.env.baseGatewayUrl)) {
      request = request.clone({
        setHeaders: {
          'Ocp-Apim-Subscription-Key': subscriptionKey,
        },
      });
    }
    return next.handle(request);
  }
}
